import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Grid } from '@/components/Grid';
import { Icon } from '@/components/Icon';

export const Wrapper = styled(Box)`
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  z-index: ${({ theme }) => theme.zIndex.searchOverlay};
  background-color: ${({ theme }) => theme.colors.white};
  border-top: ${({ theme }) =>
    `${theme.components.countrySelector.wrapper.borderWidth}px solid ${theme.colors.lightGrey}`};
`;

export const ContentWrapper = styled(Flex)`
  margin: auto;
  gap: ${({ theme }) => theme.components.countrySelector.contentWrapper.gap};
  padding: ${({ theme }) =>
    theme.components.countrySelector.contentWrapper.padding};
`;

export const MobileContentWrapper = styled(Flex)`
  margin: auto;
  flex-direction: column;
  padding-top: ${({ theme }) =>
    theme.components.countrySelector.mobileContentWrapper.paddingTop};
  padding-bottom: ${({ theme }) =>
    theme.components.countrySelector.mobileContentWrapper.paddingBottom};
  gap: ${({ theme }) =>
    theme.components.countrySelector.mobileContentWrapper.gap};
  max-width: min-content;
`;

export const TilesContainer = styled(Grid)`
  grid-gap: ${({ theme }) => theme.space.s050};
  grid-template-columns: repeat(3, 1fr);
  min-width: max-content;
`;

export const Tile = styled(Flex)<{ isMobile: boolean; isSelected: boolean }>`
  justify-content: center;
  align-items: center;
  height: ${({ theme }) => theme.space.s250};
  width: ${({ isMobile, theme }) =>
    isMobile
      ? theme.components.countrySelector.tile.variant.mobile.width
      : theme.components.countrySelector.tile.variant.desktop.width};
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.primaryBlue : theme.colors.mediumGrey};
  color: ${(props) => (props.isSelected ? props.theme.colors.white : 'auto')};
  cursor: pointer;
  transition-property: background-color, color;
  transition-duration: 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryBlue};
    color: ${({ theme }) => theme.colors.white};
  }

  p {
    font-size: ${({ theme }) => theme.components.countrySelector.tile.fontSize};
  }
`;

export const CloseButton = styled.button<{ $isMobile: boolean }>`
  position: absolute;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.secondary};

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primaryBlue};
    outline-offset: 2px;
  }

  ${({
    $isMobile,
    theme: {
      components: {
        countrySelector: {
          closeIcon: {
            variant: { desktop, mobile },
          },
        },
      },
    },
  }) =>
    $isMobile
      ? css`
          top: ${mobile.top};
          right: ${mobile.right};
        `
      : css`
          top: ${desktop.top};
          right: ${desktop.right};
        `}
`;

export const CloseIcon = styled(Icon)``;

export const SelectContainer = styled(Flex)<{ flex: number }>`
  flex: ${({ flex }) => flex};
  background-color: #fff;
  border: 2px solid ${({ theme }) => theme.colors.primaryBlue};
  position: relative;
  display: flex;
`;

export const Select = styled.select`
  flex: 1;
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.primaryBlue};
  font-family: ${({ theme }) => theme.fontFamilies.openSans};
  font-size: 13px;
  font-weight: 700;
  height: 46px;
  padding: 0;
  padding-left: 7px;
  text-transform: uppercase;
  width: 100%;
  outline: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  z-index: 10;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  text-align-last: center;
  ${({ theme: { media, space } }) => css`
    ${media.sm.up} {
      padding-left: ${space.s100};
      text-align: left;
      text-align-last: left;
    }
  `}
`;

export const ArrowBox = styled(Box)`
  display: flex;
  align-items: center;
  padding: 0;
  z-index: 0;
  pointer-events: none;
  ${({ theme }) => css`
    ${theme.media.sm.up} {
      padding: 0 10px;
    }
  `}
`;
